import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import { getCrmMasterCuisinesEndpointIdentifier } from './use-get-crm-master-cuisines-api';

const endpoint = 'ums/v1/crm/management/master-cuisines';

export type DeleteCrmMasterCuisinePayload = {
  id: number;
};

type TData = void;
type TError = AxiosError;
type TVariables = DeleteCrmMasterCuisinePayload;

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

export function useDeleteCrmMasterCuisineApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async ({ id }: TVariables): Promise<TData> => {
    const { data } = await http.delete(`${endpoint}/${id}`);
    return data;
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: endpoint,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([getCrmMasterCuisinesEndpointIdentifier]);
      if (userOnSuccess) {
        userOnSuccess(data, variables, context);
      }
    },
    ...restOptions,
  });
}
